module.exports = __webpack_public_path__ + "media/images/header4-f9544c538d118b76305107bcce50a2be.jpg";